<app-header></app-header>
<section class="">
  <div class="container-fluid">
    <div class="cnss_report">
      <div class="reportTable">
        <div class="backarrow">
          <h4><i (click)="goBack()" class="fa-solid fa-angle-left"></i>{{'Family allowance' | translate}}</h4>
        </div>
        <div class="head_2" *ngIf="employees && employees.allowance_status == 1">
          <div class="certificate">
            <div class="certificate-container" *ngIf="employees">
              <a href="{{employees.allowance_pdf}}" target="_blank">
                <div>{{'Family Allowance Certificate' | translate}}</div>
                <div class="pdf-container">
                  <div class="pdf_icon"><img src="assets/images/download.png"></div>
                </div>
              </a>
            </div>
          </div>
          <div class="sub">
            <h5 *ngIf="employees.allowance_status == 0" class="Resubmitted"><i class="fa-solid fa-circle-exclamation"></i> {{'Pending'| translate}}</h5>
            <h5 *ngIf="employees.allowance_status == 4" class="rejectedStatus"><i class="fa-solid fa-circle-exclamation"></i> {{'Rejected'| translate}}</h5>
            <h5 *ngIf="employees.allowance_status == 5" class="Resubmitted"><i class="fa-solid fa-circle-exclamation"></i> {{'Resubmitted'| translate}}</h5>
            <h5 *ngIf="employees.allowance_status == 1" class="completedStatus"><i class="fa-solid fa-check"></i>{{'Completed'| translate}}</h5>
            <h5 *ngIf="employees.allowance_status == 8" class="Resubmitted"><i class="fa-solid fa-circle-exclamation"></i>{{'waiting for employer to submit'| translate}}</h5>
            <h5 *ngIf="employees.allowance_status == 10" class="Resubmitted"><i class="fa-solid fa-circle-exclamation"></i>{{'waiting for employer to re-submit'| translate}}</h5>
          </div>
        </div>
        <div *ngIf="rejectReason && rejectReason.length >= 1 && employees.allowance_status== 4 || rejectReason && rejectReason.length >= 1 && employees.allowance_status== 1 ">
          <div class="reason_for_reject" *ngFor="let item of rejectReason; let first = first;" [ngClass]="{'hidden': !first && !showAll}">
            <div class="rejectNote reject_reasons">
              <div class="id-status">
                <img class="img-fluid" src="/assets/images/reject.png">
                <h5 class="m-0 align-self-center">{{'Rejected' | translate}}</h5>
              </div>
              <div class="d-flex">
                <h5>{{'Status2'| translate}}&nbsp;:&nbsp;
                </h5>
                <h6>{{'Rejected' | translate}}</h6>
              </div>
              <h5 class="text-capitalize">{{'Rejected by'| translate}} : {{item.rejected_by}}
              </h5>
              <h5>{{'Rejected on'| translate}} : {{item.rejected_on}}</h5>
              <h5 class="m-0">{{'Comments'| translate}} : {{item.rejected_comment}}</h5>
            </div>
            <h3 *ngIf="rejectReason && rejectReason.length > 1" (click)="view()" id="view">{{'View more' | translate}}</h3>
          </div>
        </div>
        <div class="head-2">
          <p>{{'warning' | translate}}.</p>
        </div>
        <div class="overview">
          <div class="header" *ngIf="employees">
            <div class="logo-image">
              <img src="../../../assets/images/logoWithText.png" alt="">
              <p>CASSE NATIONALE <br> DE SECURITE SOCIALE</p>
            </div>
            <div class="center">
              <p class="text-center">{{'Application for family benefits' | translate}}</p>
            </div>
            <div class="date-section">
              <div class="d-flex">
                <p>{{'Date of receipt' | translate}}: </p>
                <p class="text-dark">&nbsp;{{employees.date_of_receipt}}</p>
              </div>
              <div class="d-flex">
                <p>{{"Employee’s CNSS number" | translate}}&nbsp;:&nbsp;<span class="text-dark">{{employees.cnss}}</span></p>
              </div>
            </div>
          </div>
          <div class="table_head">
            <h5>{{'Application for family benefits' | translate}}</h5>
          </div>
          <div class="container cnss_bg">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12" *ngIf="employees">
                <ul class="sec1">
                  <li>
                    <h6 class="t1">{{'Name'| translate}}&nbsp;: </h6>
                    <h6>{{employees.employee_last_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'First name'| translate}}&nbsp;: </h6>
                    <h6>{{employees.employee_first_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Mother name'| translate}}&nbsp;: </h6>
                    <h6>{{employees.mother_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Nationality'| translate}}&nbsp;: </h6>
                    <h6>{{employees.nationality}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Phone'| translate}}&nbsp;: </h6>
                    <h6>{{employees.mobile}}</h6>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 col-md-6 col-12" *ngIf="employees">
                <ul class="sec2">
                  <li>
                    <h6 class="t1">{{'Maiden name'| translate}}&nbsp;: </h6>
                    <h6>{{employees.maiden_name}} <span *ngIf="!employees.maiden_name"> --</span></h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Father name'| translate}}&nbsp;:</h6>
                    <h6>{{employees.father_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Date of Birth'| translate}}&nbsp;:</h6>
                    <h6>{{employees.dob}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Postbox'| translate}}&nbsp;:</h6>
                    <h6>{{employees.post_box}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Email'| translate}}&nbsp;:</h6>
                    <h6>{{employees.email}}</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="overview">
          <div class="table_head_1">
            <h5>{{'CERTIFICATE OF ATTENDANCE'| translate}}</h5>
            <h5 class="second-text">({{'to be completed by the employer' | translate}})</h5>
          </div>
          <div class="container cnss_bg">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12" *ngIf="employer">
                <ul class="sec1">
                  <li>
                    <h6 class="t1">{{"Company name"| translate}}&nbsp;:
                    </h6>
                    <h6>{{employer.company_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{"CNSS N° of company"| translate}}&nbsp;: </h6>
                    <h6>{{employer.company_cnss}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{"CNSS N° of employee"| translate}}&nbsp;: </h6>
                    <h6>{{employer.employee_cnss}}</h6>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 col-md-6 col-12" *ngIf="employer">
                <ul class="sec2">
                  <li>
                    <h6 class="t1">{{"Company address"| translate}}&nbsp;: </h6>
                    <h6>{{employer.business_location}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{"Employee's first and last name"| translate}}&nbsp;:</h6>
                    <h6>{{employer.employer_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{"First date of hiring"| translate}}&nbsp;:
                    </h6>
                    <h6>{{employer.join_date}}</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <form>
            <table class="quarter_table">
              <caption>{{"INFORMATION CONCERNING THE OTHER PARENT"| translate}}</caption>
              <thead>
                <tr>
                  <th scope="col">{{'SL No' | translate}}</th>
                  <th scope="col">{{'Firstname and Lastname2'| translate}}</th>
                  <th scope="col">{{'Professional activities'| translate}}</th>
                  <th scope="col" colspan="2">{{"Registration number"| translate}}</th>
                  <th scope="col"></th>
                </tr>
                <tr>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col">{{"CNSS"| translate}}</th>
                  <th scope="col">{{'CNAMGS'| translate}}</th>
                  <th scope="col">{{"CPPF"| translate}}</th>
                  
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of spouse; let key = index">
                  <td style="width: 5%;">{{key+1}}</td>
                  <td style="width: 20%;">{{item.Spourse_name}}</td>
                  <td style="width: 30%;">{{item.occupation}}</td>
                  <td style="width: 15%;">{{item.spouse_cnss_no}}</td>
                  <td style="width: 15%;">{{item.spouse_cnamgs_no}}</td>
                  <td style="width: 15%;">{{item.spouse_cppf_no}}</td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div class="table-container">
          <form>
            <table class="quarter_table">
              <caption>{{'INFORMATION CONCERNING CHILDREN'| translate}}</caption>
              <thead>
                <tr>
                  <th scope="col">{{'SL No' | translate}}</th>
                  <th scope="col">{{'Firstname and Lastname3'| translate}}</th>
                  <th scope="col">{{'Birth date of child'| translate}}</th>
                  <th scope="col">{{"Full name of spouse"| translate}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of child; let key = index">
                  <td>{{key+1}}</td>
                  <td>{{item.child_name}}</td>
                  <td>{{item.dob}}</td>
                  <td>{{item.Spourse_name}}</td>
                  <td>{{item.spouse_cppf_no}}</td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div class="table-container" *ngIf="employees">
          <div class="made-section">
            <div class="d-flex">
              <p>{{'City of business' | translate}} :</p><span>&nbsp;{{employees.madein}}</span>
            </div>
            <div class="d-flex">
              <p>{{'Date of sending file' | translate}} : </p><span>&nbsp;{{employees.date_of_receipt}}</span>
            </div>
          </div>
        </div>
        <h4 *ngIf="employees && employees.allowance_status == 1" class="text-center amount">{{'TOTAL AMOUNT ALLOCATED' | translate}} : <span>{{employees.amount}} FCFA</span></h4>
        <h4 class="text-left">{{'Signature' | translate}}</h4>
        <div class="signature-container  mb-5">
          <div>
            <div *ngIf="signature && signature != null" class="image">
              <img src="{{signature}}">
            </div>
          </div>
        </div>
        <div class="submition" *ngIf="currentUser==1 && employees && employees.allowance_status == 8 || currentUser==1 && employees && employees.allowance_status == 10  ">
          <button (click)="employerAllowanceSubmit()" type="submit">{{'Submit' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>
